module.exports = __webpack_public_path__ + "static/img/DSC02573.974c80d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC02573.jpg
// module id = kiDp
// module chunks = 0